<template>
  <date-picker
    label="Date of Birth"
    v-model="profile.bornAt"
    @input="submit"
    @focus="initialize"
    append-icon="mdi-calendar"
    clearable
    :color="themes.candidate.light.input"
    :theme="themes.candidate.light"
  />
</template>

<script>
import _ from 'lodash'

// Vue Component
export default {
  props: {
    value: Object,
    parseId: { type: Boolean, default: true },
  },

  created() {
    if (this.parseId) {
      this.initialize()
      this.submit()
    }
  },

  data() {
    return {
      // Loading indicator
      loading: false,
      // Model (object sent to API)
      profile: JSON.parse(JSON.stringify(this.value)),
    }
  },

  methods: {
    initialize() {
      if (this.value.bornAt) return
      this.setDate()
    },

    setDate() {
      const idNumber = _.get(this, 'profile.identification')
      switch (_.get(this, 'profile.countryOfBirth')) {
        case 'ZA':
          if (idNumber.substring(0, 1) == '0' ||
              idNumber.substring(0, 1) == '1' ||
              idNumber.substring(0, 1) == '2') {
            this.profile.bornAt = this.$date(
              new Date(
                '20' + idNumber.substring(0, 2),
                idNumber.substring(2, 4) - 1,
                idNumber.substring(4, 6)
              ),
              'yyyy-MM-dd'
            )
          } else {
            this.profile.bornAt = this.$date(
              new Date(
                '19' + idNumber.substring(0, 2),
                idNumber.substring(2, 4) - 1,
                idNumber.substring(4, 6)
              ),
              'yyyy-MM-dd'
            )
          }
          break
      }
    },

    submit() {
      if (this.value.bornAt !== this.profile.bornAt) {
        this.loading = true
        this.$store.dispatch('candidate/profile/update', this.profile).then(() => {
          this.loading = false
          this.$emit('input')
        })
      }
    },
  },
}
</script>
